"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomResponse = CustomResponse;
var _props = {
  response: new Response()
};
/**
 * Create a custom response which not only contains the value of payload
 * But also provides the method from the response in prototype
 *
 * @public
 * @param {Object} rawResponse - raw response API
 * @param {any} payload - paylaod returned from fetch API call
 * @returns {void}
 */

function CustomResponse(rawResponse, payload) {
  Object.assign(this, payload);
  _props.response = rawResponse;
}

CustomResponse.prototype.getHeader = function (field) {
  return _props.response.headers.get(field);
};
//# sourceMappingURL=response.js.map